import React, { useEffect, useRef, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom';
import { format } from 'fecha';
import { Button, Card, CardActionArea, CardActions, CardContent, CircularProgress, Grid, List, ListItem, ListItemText, LinearProgress } from '@material-ui/core'
import 'office-ui-fabric-react/dist/css/fabric.css'
import { ComboBox, IIconProps, Panel, PanelType } from 'office-ui-fabric-react';
import IViewPostulante from '../../view-interfaces/IViewPostulante';
import { useStyles } from '../Inicio/InicioEstudiante.logic';
import Draggable from 'react-draggable';
import Alert from '@material-ui/lab/Alert/Alert';
import { ObtieneReglaBecasLogic } from '../../view-model/Arancel/Arancel.logic';

type Props = {
    beneficio: any;
    estado: boolean;
    onClick: any;
    moneda: number;
}
const DetalleBeneficio: React.FC<Props> = ({ beneficio, onClick, estado, moneda }) => {
    const location = useLocation();
    const [cargandoReglaBeca, setCargandoReglaBeca] = useState(false)

    function transformarMiles(valor: string) {
        const valor1 = valor + "";
        let retornar = "0";
        var splitValor;
        if (valor !== "0") {
            if (valor1.indexOf('.') === -1) {
                retornar = parseInt(valor1).toLocaleString()
            } else {
                splitValor = valor1.split('.');
                retornar = parseInt(splitValor[0]).toLocaleString()
            }
        }
        return retornar;
    }
    const ObtenerReglaBeca = (codigoBeneficio: number) => {
        let _tt = JSON.stringify(location.state);
        let _params = JSON.parse(_tt)
        /* console.log(_params) */
        setCargandoReglaBeca(true)
        let sede = _params.codCarrera.indexOf('C') === -1 ? 'SANTIAGO' : 'CONCEPCION'
        ObtieneReglaBecasLogic(selObtenerReglaBecas, codigoBeneficio, sede);
    }
    const selObtenerReglaBecas = (error: Boolean, err: string, data: any) => {
        try {
            if (error === false) {

            }
        } catch (err) {
            console.log('error', err)
        }
        setCargandoReglaBeca(false)
    }
    return (

        <>
            <Panel
                isOpen={estado}
                type={PanelType.medium}
                hasCloseButton={true}
                onDismiss={() => { onClick(false) }}
            /* 
            headerText={"Beca Matricula"} */
            >
                <div>
                    <br></br>

                    {
                        beneficio.length > 0 ?
                            <div>
                                <h5>Beneficio</h5>
                                {
                                    beneficio.map((e: any) => {
                                        if (e.montoDescuentoCLP !== 0 || e.montoDescuento !== 0) {
                                            return (
                                                <div>
                                                    <Grid container item xs={12} direction="column" alignItems="stretch">
                                                        <Card elevation={0}>
                                                            <div>
                                                                <CardContent>
                                                                    <Grid container direction="row" alignItems="stretch"  >
                                                                        <Grid item xs={12}>
                                                                            <List dense >
                                                                                <a style={{ textDecoration: 'underline', color: '#0062a1', cursor: 'pointer', float: 'right' }} onClick={() => { ObtenerReglaBeca(e.codigo) }}>{cargandoReglaBeca ? <CircularProgress color="inherit" size={20} disableShrink /> : "Info beca"}</a>
                                                                                <ListItem >
                                                                                    <div style={{ display: 'flex' }}>
                                                                                        <label>Nombre Beneficio: </label>&nbsp;&nbsp;<ListItemText style={{ marginTop: 2 }} secondary={e.nombre} />
                                                                                    </div>
                                                                                </ListItem>
                                                                                {/* <ListItem >
                                                                                <div style={{ display: 'flex' }}>
                                                                                    <label>Fecha Asignada: </label>&nbsp;&nbsp;<ListItemText style={{ marginTop: 2 }} secondary={e.fechaAsignacion} />
                                                                                </div>
                                                                            </ListItem> */}
                                                                                <ListItem >
                                                                                    <div style={{ display: 'flex' }}>
                                                                                        <label>Porcentaje Descuento: </label>&nbsp;&nbsp;<ListItemText style={{ marginTop: 2 }} secondary={parseFloat(e.porcentajeFinal).toFixed(2) + "%"} />
                                                                                    </div>
                                                                                </ListItem>
                                                                                {
                                                                                    moneda === 1 ?
                                                                                        ""
                                                                                        :
                                                                                        <ListItem >
                                                                                            <div style={{ display: 'flex' }}>
                                                                                                <label>Monto Descuento {moneda === 2 ? "(UF)" : "(USD)"}: </label>&nbsp;&nbsp;<ListItemText style={{ marginTop: 2 }} secondary={parseFloat(e.montoDescuento).toFixed(2)} />
                                                                                            </div>
                                                                                        </ListItem>
                                                                                }
                                                                                <ListItem >
                                                                                    <div style={{ display: 'flex' }}>
                                                                                        <label>Monto Descuento (CLP):  </label>&nbsp;&nbsp;<ListItemText style={{ marginTop: 2 }} secondary={"$" + transformarMiles(e.montoDescuentoCLP)} />
                                                                                    </div>
                                                                                </ListItem>
                                                                            </List>
                                                                        </Grid>
                                                                    </Grid>
                                                                </CardContent>
                                                            </div>
                                                        </Card>
                                                    </Grid>
                                                </div>

                                            )
                                        } else {
                                            return (
                                                <div style={{ textAlign: 'center' }}></div>
                                            )
                                        }
                                    })
                                }
                            </div>
                            : ""
                    }
                </div>
            </Panel>
        </>
    );
}

export default DetalleBeneficio;
